/**
 * Contexto de navegación para clasificación de recetas y listado según módulo (Producción, concesionaria legacy, Restaurantes).
 */
export function getRecetasModuleContext(pathname = '') {
  if (pathname.startsWith('/restaurantes')) {
    return {
      moduleBase: '/restaurantes',
      moduleName: 'Restaurantes',
      clasificacionBase: '/restaurantes/clasificacion-recetas',
    };
  }
  if (pathname.startsWith('/produccion')) {
    return {
      moduleBase: '/produccion',
      moduleName: 'Producción',
      clasificacionBase: '/produccion/clasificacion-recetas',
    };
  }
  // Legacy: redirigir desde rutas antiguas de concesionaria
  return {
    moduleBase: '/produccion-concesionaria',
    moduleName: 'Producción concesionaria',
    clasificacionBase: '/produccion-concesionaria/clasificacion-recetas',
  };
}
